import IntroBreakdownModule from "./introBreakdownModule";
import IntroBreakdownSaga from "./redux/introBreakdownSagas";
import IntroBreakdownReducer from "./redux/introBreakdownReducer";

export default {
  Component: IntroBreakdownModule,
  moduleName: "introBreakdown",
  saga: IntroBreakdownSaga(),
  reducer: IntroBreakdownReducer
};
